/**
 * Кастомная иконка «Уведомление» — outline вариант со stroke
 *
 * stroke="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function NotificationOutlineIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.01 17.75C16.8199 17.75 19.0452 17.0653 19.26 14.3169C19.26 11.5704 17.7087 11.747 17.7087 8.37714C17.7087 5.74491 15.4603 2.75 12.01 2.75C8.55967 2.75 6.31138 5.74491 6.31138 8.37714C6.31138 11.747 4.76001 11.5704 4.76001 14.3169C4.97576 17.0757 7.20093 17.75 12.01 17.75Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3429 20C13.059 21.6568 11.0562 21.6765 9.76001 20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
